import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fcae6a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "billing-details-container" }
const _hoisted_2 = { class: "column" }
const _hoisted_3 = {
  key: 0,
  class: "column"
}
const _hoisted_4 = { class: "lookup-container" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "Search for an address or enter an address manually", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "Address", -1))

import { PropType, computed } from "vue";
import AcquaintTextbox from "@/components/ui/inputs/acquaint-textbox.vue";
import { Address } from "@/types/generic/Address";
import AutoAddressWrapper from "@/components/ui/address/auto-address-wrapper.vue";
import { ContactsValidation } from "acquaint-api/validation/ContactsValidation";
import scrollView from "@/components/ui/scroll-view.vue";
import { SwitchBillTo } from "@/enums/utility-switching/SwitchBillTo";
import BillToSelect from "./bill-to-select.vue";
import { LandlordPersonalInfo } from "@/types/switches/LandlordPersonalInfo";
import { TextboxValueChangeEvent } from "@/enums/ui/inputs/TextboxValueChangeEvent";
import IrishCountiesSingleSelect from "@/components/ui/dropdowns/irish-counties-single-select.vue";
import { CountryCode } from "bright-logic-core/src/CountryCode";


export default /*#__PURE__*/_defineComponent({
  __name: 'billing-address-page',
  props: {
  /**
   * The address of the landlord.
   * @type {Address}
   * @required
   */
  landlordAddress: {
    type: Object as PropType<Address>,
    required: true,
  },

  /**
   * The identifier for the billing option, representing who to bill.
   * @type {number}
   * @required
   */
  billTo: {
    type: Number,
    required: true,
  },

  /**
   * The personal information of the landlord.
   * @type {LandlordPersonalInfo}
   * @required
   */
  landlord: {
    type: Object as PropType<LandlordPersonalInfo>,
    required: true,
  },
},
  emits: ["update:landlordAddress", "update:billTo"],
  setup(__props, { emit }) {

const props = __props;





const landlordAddress = computed({
  get: () => props.landlordAddress,
  set: (value: Address) => emit("update:landlordAddress", value),
});

const billTo = computed({
  get: () => props.billTo,
  set: (value: Number) => emit("update:billTo", value),
});

const onAddressFound = (e: Address) => {
  landlordAddress.value = e;
};

// To avoid user confusion, only show address fields when billing the landlord
const showAddressFields = computed(
  () => props.billTo === SwitchBillTo.Landlord,
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(scrollView, null, {
    default: _withCtx(() => [
      _createElementVNode("section", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BillToSelect, {
            modelValue: billTo.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((billTo).value = $event)),
            landlord: __props.landlord
          }, null, 8, ["modelValue", "landlord"])
        ]),
        (showAddressFields.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(AutoAddressWrapper, { onOnAddressFound: onAddressFound })
              ]),
              _hoisted_6,
              _createVNode(AcquaintTextbox, {
                modelValue: landlordAddress.value.propertyName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((landlordAddress.value.propertyName) = $event)),
                label: "Property Name",
                fieldValidation: _unref(ContactsValidation).HomeProperty,
                validationGroup: "billing",
                requiredInput: false,
                "value-change-event": _unref(TextboxValueChangeEvent).Change
              }, null, 8, ["modelValue", "fieldValidation", "value-change-event"]),
              _createVNode(AcquaintTextbox, {
                modelValue: landlordAddress.value.street,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((landlordAddress.value.street) = $event)),
                label: "Street",
                validationGroup: "billing",
                fieldValidation: _unref(ContactsValidation).HomeStreet,
                requiredInput: true,
                "value-change-event": _unref(TextboxValueChangeEvent).Change
              }, null, 8, ["modelValue", "fieldValidation", "value-change-event"]),
              _createVNode(AcquaintTextbox, {
                modelValue: landlordAddress.value.locality,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((landlordAddress.value.locality) = $event)),
                label: "Locality",
                validationGroup: "billing",
                fieldValidation: _unref(ContactsValidation).HomeLocality,
                requiredInput: false,
                "value-change-event": _unref(TextboxValueChangeEvent).Change
              }, null, 8, ["modelValue", "fieldValidation", "value-change-event"]),
              _createVNode(AcquaintTextbox, {
                modelValue: landlordAddress.value.town,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((landlordAddress.value.town) = $event)),
                fieldValidation: _unref(ContactsValidation).HomeTown,
                label: "Town",
                validationGroup: "billing",
                requiredInput: true,
                "value-change-event": _unref(TextboxValueChangeEvent).Change
              }, null, 8, ["modelValue", "fieldValidation", "value-change-event"]),
              _createVNode(IrishCountiesSingleSelect, {
                modelValue: landlordAddress.value.region,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((landlordAddress.value.region) = $event)),
                label: "County",
                validationGroup: "billing",
                requiredInput: true
              }, null, 8, ["modelValue"]),
              _createVNode(AcquaintTextbox, {
                modelValue: landlordAddress.value.postCode,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((landlordAddress.value.postCode) = $event)),
                fieldValidation: _unref(ContactsValidation).HomePostcode,
                label: "Eircode",
                validationGroup: "billing",
                requiredInput: false,
                "value-change-event": _unref(TextboxValueChangeEvent).Change,
                "country-code": _unref(CountryCode).Ireland
              }, null, 8, ["modelValue", "fieldValidation", "value-change-event", "country-code"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})